import React from "react";
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip,
    PieChart,
    Pie,
    Cell,
    Legend,
} from "recharts";
import { SectionCard, StatCard, isSubscriptionCurrentlyActive } from "../adminShared";

const OverviewTab = ({
    summary,
    users,
    accounts,
    subscriptions,
    overviewBarData,
    subscriptionTypeData,
    subscriptionHealthData,
}) => (
    <div className="space-y-6">
        <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-6">
            <StatCard label="Users" value={summary?.users ?? users.length} />
            <StatCard
                label="Active users"
                value={summary?.active_users ?? users.filter((u) => u.is_active).length}
            />
            <StatCard label="Companies" value={summary?.accounts ?? accounts.length} />
            <StatCard
                label="Active companies"
                value={summary?.active_accounts ?? accounts.filter((account) => account.is_active).length}
            />
            <StatCard
                label="Subscriptions"
                value={summary?.subscriptions ?? subscriptions.length}
            />
            <StatCard
                label="Active subscriptions"
                value={
                    summary?.active_subscriptions ??
                    subscriptions.filter(isSubscriptionCurrentlyActive).length
                }
            />
        </div>

        <div className="grid gap-6 xl:grid-cols-2">
            <SectionCard
                title="Entity status"
                description="Quick comparison of total vs active records across the platform."
            >
                <div className="h-80 w-full">
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={overviewBarData}>
                            <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                            <XAxis dataKey="name" tick={{ fontSize: 12 }} />
                            <YAxis allowDecimals={false} tick={{ fontSize: 12 }} />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="active" name="Active" fill="#0f172a" radius={[8, 8, 0, 0]} />
                            <Bar
                                dataKey="inactive"
                                name="Inactive / expired"
                                fill="#94a3b8"
                                radius={[8, 8, 0, 0]}
                            />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </SectionCard>

            <SectionCard
                title="Subscription types"
                description="How access is distributed between company and individual plans."
            >
                <div className="h-80 w-full">
                    <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                            <Pie
                                data={subscriptionTypeData}
                                dataKey="value"
                                nameKey="name"
                                cx="50%"
                                cy="50%"
                                outerRadius={95}
                                label
                            >
                                {subscriptionTypeData.map((entry, index) => (
                                    <Cell
                                        key={`${entry.name}-${index}`}
                                        fill={index === 0 ? "#0f172a" : "#94a3b8"}
                                    />
                                ))}
                            </Pie>
                            <Tooltip />
                            <Legend />
                        </PieChart>
                    </ResponsiveContainer>
                </div>
            </SectionCard>
        </div>

        <SectionCard
            title="Subscription expiry timeline"
            description="Useful for spotting renewals that need action soon."
        >
            <div className="h-72 w-full">
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={subscriptionHealthData}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                        <XAxis dataKey="name" tick={{ fontSize: 12 }} />
                        <YAxis allowDecimals={false} tick={{ fontSize: 12 }} />
                        <Tooltip />
                        <Bar dataKey="value" fill="#334155" radius={[8, 8, 0, 0]} />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </SectionCard>
    </div>
);

export default OverviewTab;
